import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from "react-icons/fa";

function Header() {
    // State to hold the total items in the cart
    const [totalAmountInCart, setTotalAmountInCart] = useState(0);

    // Function to get the total items in the cart
    const getTotalAmountInCart = () => {
        const cart = JSON.parse(localStorage.getItem("cart"));
        let total = 0;
        if (cart) {
            cart.forEach(item => {
                total += item.quantity;
            });
        }
        setTotalAmountInCart(total);
    }

    // UseEffect to get the total items in the cart
    useEffect(() => {
        getTotalAmountInCart();
    }, [JSON.parse(localStorage.getItem("cart"))]);

    return (
        <nav className='products-navbar'>
            <h2>Mark Gamble</h2>
            <ul>
                <li>
                    <Link to="/">CONTRACTING</Link>
                </li>
                <li>
                    <Link to="/">EXCAVATION</Link>
                </li>
                <li>
                    <Link to="/">MAINTENANCE</Link>
                </li>
                <li>
                    <Link to="/">CONTACT US</Link>
                </li>
                <li className='d-flex align-items-center'>
                    <Link className='d-flex align-items-center cart-icon' to="/cart">
                        <FaShoppingCart />
                        {totalAmountInCart > 0 && <span className="cart-qty-badge">{totalAmountInCart}</span>}
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default Header;
